/**
 * This is the tag when you need it to be a link.
 * Clicks bring you to the category page.
 */

import { Link } from "react-router-dom";

import { nFormatter } from "utils/parseNumber";
import { ITag, INiche } from "services/types";
import { routes } from "routes";
import { clsx } from "clsx";
import DefaultUserIcon from "components/icons/default_userpic.svg";

import "./styles.scss";

interface ITagLinkProps {
  tag: INiche | ITag;
  counts: boolean;
}

export const TagLink = ({ tag, counts }: ITagLinkProps): JSX.Element => {
  const isOfTypeNiche = (someTag: INiche | ITag): someTag is INiche => "id" in someTag;
  const isNiche = isOfTypeNiche(tag);

  return (
    <Link
      to={isNiche ? routes.niche(tag.id) : routes.singleTag(tag.name)}
      className={clsx("tagItem", isNiche && "tagItemNiche")}
      title={tag.name}
    >
      {isNiche && (
        <img className="icon" loading="lazy" src={tag.thumbnail || DefaultUserIcon} width="24" height="24" alt={tag.name} />
      )}

      {tag.name}

      {counts && (
        <span className="count">{nFormatter(isNiche ? tag.gifs : tag.count)}</span>
      )}
    </Link>
  );
};
